import { configureStore } from "@reduxjs/toolkit";
import { userApi } from "@store/services/user";
import { notificationsApi } from "@store/services/notifications";
import { partnerApi } from "@store/services/partner";
import { documentsApi } from "@store/services/documents";
import { identificationFilesApi } from "@store/services/identificationFiles";
import { identificationFilesNonUserApi } from "@store/services/identificationFilesNonUser";
import { identificationFilesMagicLinkApi } from "@store/services/identificationFilesMagicLink";
import { myDocumentsPreviewMagicLinkApi } from "@store/services/myDocumentsPreviewMagicLink";
import { accountSetupMagicLinkApi } from "@store/services/accountSetupMagicLink";
import { identificationFilesUploadApi } from "@store/services/identificationFilesUpload";
import { bifrostBookingsApi } from "./services/bifrostBookings";
import { bifrostFilesApi } from "./services/bifrostFiles";
import { bifrostFilesMagicLinkApi } from "./services/bifrostFilesMagicLink";
import { lawdocsApi } from "./services/lawdocs";
import { bookingMetadataApi } from "./services/bookingMetadata";
import { bookingMetadataMagicLinkApi } from "./services/bookingMetadataMagicLink";
import { bookingMetadataNonUserApi } from "./services/bookingMetadataNonUser";
import { middleServiceMagicLinkApi } from "./services/middleServiceMagicLink";
import { magicLinkResendApi } from "./services/magicLinkResend";
import { authenticationApi } from "./services/authentication";
import { documentInfoApi } from "./services/documentInfo";
import { bundleInfoApi } from "./services/bundleInfo";
import { shopifyApi } from "./services/shopify";
import { userDocumentsApi } from "./services/userDocuments";
import { userInfoApi } from "./services/userInfo";
import { trackingInfoApi } from "./services/trackingInfo";
import { onboardingApi } from "./services/onboarding";
import { requestCallApi } from "./services/requestCall";
import { campaignVoucherApi } from "./services/campaignVoucher";

import rootReducer from "./rootReducer";

export const storeApis = [
  userApi,
  notificationsApi,
  partnerApi,
  documentsApi,
  identificationFilesApi,
  identificationFilesNonUserApi,
  identificationFilesUploadApi,
  identificationFilesMagicLinkApi,
  bifrostBookingsApi,
  bifrostFilesApi,
  bifrostFilesMagicLinkApi,
  lawdocsApi,
  bookingMetadataApi,
  bookingMetadataMagicLinkApi,
  bookingMetadataNonUserApi,
  middleServiceMagicLinkApi,
  magicLinkResendApi,
  authenticationApi,
  myDocumentsPreviewMagicLinkApi,
  accountSetupMagicLinkApi,
  documentInfoApi,
  bundleInfoApi,
  shopifyApi,
  userDocumentsApi,
  userInfoApi,
  trackingInfoApi,
  onboardingApi,
  requestCallApi,
  campaignVoucherApi,
];

export const store = configureStore({
  reducer: rootReducer,
  middleware: (getDefaultMiddleware) => {
    const defaultMiddleware = getDefaultMiddleware({ serializableCheck: false });
    return [...defaultMiddleware, ...storeApis.map((api) => api.middleware)] as typeof defaultMiddleware;
  },
});

export type AppDispatch = typeof store.dispatch;

export default store;
